/* ==========================================================================
   NEOWALT — GLOBAL INDEX SCRIPT
   Hero NWM · Hero NW (Quiz) · Mini Comparateur · Cart · Favorites
   Optimisé Shopify : theme editor events, pause anims OOV, a11y, lazy cart
   ========================================================================== */
(function () {
  'use strict';

  if (window.__neowaltLoaded) return;
  window.__neowaltLoaded = true;

  // --------------------------------------------------------------------------
  // 0. UTILS
  // --------------------------------------------------------------------------
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observers = [];

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function rafThrottle(fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      var ctx = this, args = arguments;
      window.requestAnimationFrame(function () {
        fn.apply(ctx, args);
        ticking = false;
      });
    };
  }

 const safeParse = (json, fb) => {
  if (json === null || json === undefined) return fb;
  try { const v = JSON.parse(json); return v === null ? fb : v; } catch { return fb; }
};

  function trackObserver(o) { observers.push(o); return o; }

  function disconnectAll() {
    observers.forEach(function (o) { try { o.disconnect(); } catch (e) {} });
    observers = [];
  }

  // --------------------------------------------------------------------------
  // 1. INIT — Boot complet, ré-exécutable (theme editor friendly)
  // --------------------------------------------------------------------------
  function bootAll(scope) {
    initRevealAndCounters(scope);
    initSectionPause(scope);
    initTilt(scope);
    initQuiz(scope);
    initLiveProof(scope);
    initMiniCompareSlider(scope);
    initFavoritesSync();
    initGoogleReviews(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  // Theme editor events
  document.addEventListener('shopify:section:load', function (e) {
    bootAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function () {
    disconnectAll();
  });
  document.addEventListener('shopify:section:select', function (e) {
    bootAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    if (block && block.closest && block.closest('[data-hero-chips]')) {
      block.click();
    }
  });

  // --------------------------------------------------------------------------
  // 2. REVEAL + COUNTERS + STICKY MOBILE CTA (un seul observer)
  // --------------------------------------------------------------------------
  function initRevealAndCounters(scope) {
    if (!('IntersectionObserver' in window)) {
      $$('[data-hero-reveal]', scope).forEach(function (el) { el.classList.add('is-visible'); });
      $$('[data-hero-count]', scope).forEach(function (el) {
        var t = parseInt(el.dataset.heroCount, 10);
        if (t) el.textContent = t.toLocaleString('fr-FR');
      });
      return;
    }

    var io = trackObserver(new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;

        if (entry.isIntersecting && el.hasAttribute('data-hero-reveal')) {
          el.classList.add('is-visible');
          io.unobserve(el);
        }

        if (entry.isIntersecting && el.hasAttribute('data-hero-count')) {
          animateCount(el);
          io.unobserve(el);
        }

        if (el.hasAttribute('data-hero-cta-main')) {
          var mobileCta = $('[data-hero-mobile-cta]');
          if (mobileCta) {
            mobileCta.classList.toggle('is-visible', !entry.isIntersecting);
            mobileCta.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
          }
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }));

    $$('[data-hero-reveal], [data-hero-count]', scope).forEach(function (el) {
      if (!el.classList.contains('is-visible')) io.observe(el);
    });

    var mainCta = $('[data-hero-cta]', scope);
    if (mainCta) {
      mainCta.setAttribute('data-hero-cta-main', '');
      io.observe(mainCta);
    }
  }

function animateCount(el) {
  const target = parseInt(el.dataset.heroCount, 10);

  // Cible le 1er text node (le chiffre) sans toucher au <sup> suffixe
  let textNode = [...el.childNodes].find(n => n.nodeType === Node.TEXT_NODE);
  if (!textNode) {
    textNode = document.createTextNode('0');
    el.insertBefore(textNode, el.firstChild);
  }

  if (!target || isNaN(target) || reduced) {
    textNode.nodeValue = target ? target.toLocaleString('fr-FR') : '0';
    return;
  }

  const start = performance.now();
  const tick = (now) => {
    const p = Math.min((now - start) / 2000, 1);
    const ease = 1 - (1 - p) ** 4;
    textNode.nodeValue = Math.floor(ease * target).toLocaleString('fr-FR');
    if (p < 1) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}

  // --------------------------------------------------------------------------
  // 3. PAUSE ANIMATIONS HORS VIEWPORT (perf mobile)
  //    Ajoute .is-paused → CSS coupe les anims (animation-play-state: paused)
  // --------------------------------------------------------------------------
  function initSectionPause(scope) {
    if (!('IntersectionObserver' in window)) return;

    var sections = $$('.hero-nwm, .hero-nw, .mini-compare', scope);
    if (!sections.length) return;

    var io = trackObserver(new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-paused', !entry.isIntersecting);
      });
    }, { threshold: 0 }));

    sections.forEach(function (s) { io.observe(s); });
  }

  // --------------------------------------------------------------------------
  // 4. TILT — image hero, scroll-driven, GPU
  // --------------------------------------------------------------------------
  function initTilt(scope) {
    var visual = $('[data-hero-tilt] .hero-nwm__product', scope);
    if (!visual || reduced) return;

    var inView = false;

    if ('IntersectionObserver' in window) {
      var visibility = trackObserver(new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }, { threshold: 0 }));
      visibility.observe(visual);
    } else {
      inView = true;
    }

    var update = rafThrottle(function () {
      if (!inView) return;
      var rect = visual.getBoundingClientRect();
      var vh = window.innerHeight;
      var progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - vh / 2) / vh));
      visual.style.transform = 'rotateX(' + (progress * -10) + 'deg) translateY(' + (progress * 12) + 'px)';
    });

    window.addEventListener('scroll', update, { passive: true });
  }

  // --------------------------------------------------------------------------
  // 5. QUIZ — chips + image swap + CTA + a11y clavier
  // --------------------------------------------------------------------------
  function initQuiz(scope) {
    var quizContainer = $('[data-hero-chips]', scope);
    if (!quizContainer || quizContainer.dataset.heroQuizInit === '1') return;
    quizContainer.dataset.heroQuizInit = '1';

    var ctas = $$('[data-hero-cta]');
    var ctaLabels = $$('[data-hero-cta-label]');
    var img = $('[data-hero-product-img]');

    quizContainer.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-hero-chip]');
      if (!chip) return;
      selectChip(chip);
    });

    quizContainer.addEventListener('keydown', function (e) {
      var chips = $$('[data-hero-chip]', quizContainer);
      var idx = chips.indexOf(document.activeElement);
      if (idx === -1) return;

      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = chips[(idx + 1) % chips.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = chips[(idx - 1 + chips.length) % chips.length];
      else if (e.key === 'Home') next = chips[0];
      else if (e.key === 'End') next = chips[chips.length - 1];

      if (next) {
        e.preventDefault();
        next.focus();
        selectChip(next);
      }
    });

    function selectChip(chip) {
      $$('[data-hero-chip]', quizContainer).forEach(function (c) {
        c.setAttribute('aria-checked', 'false');
        c.setAttribute('tabindex', '-1');
      });
      chip.setAttribute('aria-checked', 'true');
      chip.setAttribute('tabindex', '0');

      if (chip.dataset.ctaLabel) {
        ctaLabels.forEach(function (l) { l.textContent = chip.dataset.ctaLabel; });
      }
      if (chip.dataset.ctaHref && chip.dataset.ctaHref !== '#') {
        ctas.forEach(function (cta) { cta.setAttribute('href', chip.dataset.ctaHref); });
      }

      if (img && chip.dataset.productImg && img.src !== chip.dataset.productImg) {
        img.classList.add('is-updating');
        var newSrc = chip.dataset.productImg;
        var newAlt = chip.dataset.productAlt || '';
        setTimeout(function () {
          img.src = newSrc;
          if (newAlt) img.alt = newAlt;
          requestAnimationFrame(function () { img.classList.remove('is-updating'); });
        }, 200);
      }
    }
  }

  // --------------------------------------------------------------------------
  // 6. LIVE PROOF — rotateur de citations (pause hover)
  // --------------------------------------------------------------------------
  function initLiveProof(scope) {
    var quotes = $$('[data-hero-quote]', scope);
    if (quotes.length < 2 || reduced) return;

    var container = quotes[0].parentElement;
    var idx = 0;
    var paused = false;

    setInterval(function () {
      if (paused) return;
      quotes[idx].classList.remove('is-active');
      idx = (idx + 1) % quotes.length;
      quotes[idx].classList.add('is-active');
    }, 5000);

    if (container) {
      container.addEventListener('mouseenter', function () { paused = true; });
      container.addEventListener('mouseleave', function () { paused = false; });
      container.addEventListener('focusin', function () { paused = true; });
      container.addEventListener('focusout', function () { paused = false; });
    }
  }

  // --------------------------------------------------------------------------
  // 7. MINI COMPARE — slider mobile (dots + drag-to-scroll)
  // --------------------------------------------------------------------------
  function initMiniCompareSlider(scope) {
    var slider = $('.mini-compare__mobile-slider', scope);
    if (!slider || slider.dataset.miniCompareInit === '1') return;
    slider.dataset.miniCompareInit = '1';

    var slides = $$('.mini-compare__slide', slider);
    if (slides.length < 1) return;

    // Dots
    var dotsContainer = slider.parentNode.querySelector('.mini-compare__dots');
    if (!dotsContainer) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'mini-compare__dots';
      dotsContainer.setAttribute('role', 'tablist');
      dotsContainer.setAttribute('aria-label', 'Navigation produits');
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mini-compare__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Aller au produit ' + (i + 1));
        dot.dataset.idx = i;
        dotsContainer.appendChild(dot);
      });
      slider.parentNode.insertBefore(dotsContainer, slider.nextSibling);
    }
    var dots = $$('.mini-compare__dot', dotsContainer);

    dotsContainer.addEventListener('click', function (e) {
      var dot = e.target.closest('.mini-compare__dot');
      if (!dot) return;
      var i = parseInt(dot.dataset.idx, 10);
      if (slides[i]) {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    });

    if ('IntersectionObserver' in window) {
      var slideObs = trackObserver(new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0.55) {
            var i = slides.indexOf(entry.target);
            if (i !== -1) {
              dots.forEach(function (d) { d.classList.remove('is-active'); });
              if (dots[i]) dots[i].classList.add('is-active');
            }
          }
        });
      }, { root: slider, threshold: [0.55] }));
      slides.forEach(function (s) { slideObs.observe(s); });
    }

    // Drag-to-scroll souris
    var isDown = false, startX = 0, scrollLeft = 0;
    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      slider.classList.add('is-dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    function endDrag() { isDown = false; slider.classList.remove('is-dragging'); }
    slider.addEventListener('mouseleave', endDrag);
    slider.addEventListener('mouseup', endDrag);
    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  }

  // --------------------------------------------------------------------------
  // 8. FAVORITES SYNC (localStorage cross-tab)
  // --------------------------------------------------------------------------
  function initFavoritesSync() {
    if (window.__neowaltFavSyncInit) return;
    window.__neowaltFavSyncInit = true;

    function syncFavs() {
      var favs = safeParse(localStorage.getItem('cw_favorites'), []);
      $$('.nw-fav-preview').forEach(function (btn) {
        var id = btn.dataset.favoriteId;
        var isFav = favs.indexOf(id) !== -1;
        btn.textContent = isFav ? '❤️' : '🤍';
        btn.classList.toggle('active', isFav);
        btn.setAttribute('aria-pressed', isFav ? 'true' : 'false');
        btn.setAttribute('aria-label', isFav ? 'Retirer des favoris' : 'Ajouter aux favoris');
      });
    }

    setTimeout(syncFavs, 500);
    window.addEventListener('storage', function (e) { if (e.key === 'cw_favorites') syncFavs(); });
  }

  // --------------------------------------------------------------------------
  // 8.b GOOGLE REVIEWS — import live via Places API (cache 24h)
  // --------------------------------------------------------------------------
  var gMapsLoadingPromise = null;

  function loadGoogleMapsPlaces(apiKey) {
    if (window.google && window.google.maps && window.google.maps.places) {
      return Promise.resolve(window.google);
    }
    if (gMapsLoadingPromise) return gMapsLoadingPromise;

    gMapsLoadingPromise = new Promise(function (resolve, reject) {
      var cb = '__nwGmReady_' + Date.now();
      window[cb] = function () {
        delete window[cb];
        resolve(window.google);
      };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey)
        + '&libraries=places&callback=' + cb + '&loading=async&v=weekly';
      s.async = true;
      s.defer = true;
      s.onerror = function () {
        gMapsLoadingPromise = null;
        reject(new Error('Google Maps load failed'));
      };
      document.head.appendChild(s);
    });
    return gMapsLoadingPromise;
  }

  function fetchPlaceDetails(placeId, apiKey) {
    return loadGoogleMapsPlaces(apiKey).then(function (google) {
      return new Promise(function (resolve, reject) {
        var service = new google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails({
          placeId: placeId,
          fields: ['reviews', 'rating', 'user_ratings_total'],
          language: 'fr'
        }, function (place, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK && place) {
            resolve(place);
          } else {
            reject(new Error('Place details failed: ' + status));
          }
        });
      });
    });
  }

  function getCachedPlace(placeId) {
    try {
      var raw = localStorage.getItem('nw_gr_' + placeId);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (Date.now() - cached.ts < 24 * 3600 * 1000) return cached.data;
    } catch (e) {}
    return null;
  }

  function setCachedPlace(placeId, data) {
    try {
      localStorage.setItem('nw_gr_' + placeId, JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) {}
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getInitials(name) {
    var parts = String(name || '').trim().split(/\s+/);
    if (parts.length === 0 || !parts[0]) return '?';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  function renderStars(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var cls = i <= rating ? 'reviews-google__star reviews-google__star--filled' : 'reviews-google__star';
      html += '<svg class="' + cls + '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">'
        + '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    return html;
  }

  function googleGSvg() {
    return '<svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">'
      + '<path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>'
      + '<path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>'
      + '<path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>'
      + '<path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/></svg>';
  }

  function buildReviewCard(review, idx) {
    var article = document.createElement('article');
    article.className = 'reviews-google__card is-visible';
    article.style.setProperty('--gr-idx', idx);
    article.setAttribute('data-hero-reveal', '');

    var avatar = review.profile_photo_url
      ? '<img class="reviews-google__avatar" src="' + escapeHtml(review.profile_photo_url) + '" alt="" loading="lazy" width="56" height="56" referrerpolicy="no-referrer">'
      : '<div class="reviews-google__avatar" aria-hidden="true">' + escapeHtml(getInitials(review.author_name)) + '</div>';

    article.innerHTML =
      '<span class="reviews-google__quote" aria-hidden="true">"</span>'
      + '<span class="reviews-google__card-stars" aria-label="' + review.rating + ' étoiles sur 5">' + renderStars(review.rating) + '</span>'
      + '<p class="reviews-google__card-text">' + escapeHtml(review.text || '') + '</p>'
      + '<footer class="reviews-google__card-footer">'
      + avatar
      + '<div class="reviews-google__author">'
      +   '<strong>' + escapeHtml(review.author_name || 'Anonyme') + '</strong>'
      +   '<span>' + escapeHtml(review.relative_time_description || '') + '</span>'
      + '</div>'
      + '<div class="reviews-google__verified" aria-label="Avis vérifié Google">' + googleGSvg() + '</div>'
      + '</footer>';

    return article;
  }

  function applyPlaceData(section, place) {
    var grid = section.querySelector('[data-g-grid]');
    if (!grid) return;

    var minRating = parseInt(section.dataset.gMinRating, 10) || 0;
    var maxReviews = parseInt(section.dataset.gMaxReviews, 10) || 6;
    var reviews = (place.reviews || [])
      .filter(function (r) { return r.rating >= minRating; })
      .slice(0, maxReviews);

    if (!reviews.length) return;

    // Update stats
    if (typeof place.rating === 'number') {
      var ratingEl = section.querySelector('[data-g-rating]');
      if (ratingEl) ratingEl.textContent = place.rating.toFixed(1).replace('.', ',');
    }
    if (typeof place.user_ratings_total === 'number') {
      var countEl = section.querySelector('[data-g-count]');
      if (countEl) countEl.textContent = place.user_ratings_total.toLocaleString('fr-FR');
    }

    // Replace grid content with real reviews
    var fragment = document.createDocumentFragment();
    reviews.forEach(function (r, i) {
      fragment.appendChild(buildReviewCard(r, i));
    });
    grid.innerHTML = '';
    grid.appendChild(fragment);

    section.classList.remove('is-loading');
    section.classList.add('is-loaded');
  }

  function initGoogleReviews(scope) {
    var sections = $$('.reviews-google--live', scope);
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.dataset.grInit === '1') return;
      section.dataset.grInit = '1';

      var placeId = section.dataset.gPlaceId;
      var apiKey = section.dataset.gApiKey;
      if (!placeId || !apiKey) return;

      // Lazy : on attend que la section soit (presque) en viewport
      var startFetch = function () {
        var cached = getCachedPlace(placeId);
        if (cached) {
          applyPlaceData(section, cached);
          return;
        }
        fetchPlaceDetails(placeId, apiKey)
          .then(function (place) {
            setCachedPlace(placeId, place);
            applyPlaceData(section, place);
          })
          .catch(function (err) {
            // En cas d'erreur, on garde le contenu fallback
            section.classList.remove('is-loading');
            console.warn('[Neowalt] Google reviews fetch failed:', err.message);
          });
      };

      if ('IntersectionObserver' in window) {
        var io = trackObserver(new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.disconnect();
              startFetch();
            }
          });
        }, { rootMargin: '200px' }));
        io.observe(section);
      } else {
        startFetch();
      }
    });
  }

  // --------------------------------------------------------------------------
  // 9. CART BRIDGE (lazy — chargé au 1er clic)
  // --------------------------------------------------------------------------
  var cartBridgeLoaded = false;
  function ensureCartBridge() {
    if (cartBridgeLoaded) return;
    cartBridgeLoaded = true;

    function waitForFn(name, timeout) {
      timeout = timeout || 1200;
      return new Promise(function (resolve) {
        if (typeof window[name] === 'function') return resolve(window[name]);
        var start = performance.now();
        var iv = setInterval(function () {
          if (typeof window[name] === 'function') {
            clearInterval(iv);
            resolve(window[name]);
          } else if (performance.now() - start > timeout) {
            clearInterval(iv);
            resolve(null);
          }
        }, 100);
      });
    }

    function resetBtn(btn, original, isError) {
      if (!btn) return;
      btn.innerText = isError ? 'Erreur' : original;
      btn.disabled = false;
      btn.style.opacity = '1';
      btn.dataset.adding = 'false';
      if (isError) setTimeout(function () { btn.innerText = original; }, 1200);
    }

    function fallbackAdd(url, image, title, price, btn) {
      if (!btn || btn.dataset.adding === 'true') return;
      btn.dataset.adding = 'true';
      var original = btn.innerText;
      btn.innerText = 'Patientez...';
      btn.disabled = true;
      btn.style.opacity = '0.7';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var clean = typeof url === 'string' ? url.split('?')[0] : '';
      if (clean.endsWith('/')) clean = clean.slice(0, -1);
      if (clean.startsWith('http')) {
        try { clean = new URL(clean).pathname; } catch (e) {}
      }

      fetch(clean + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('product 404'); return r.json(); })
        .then(function (data) {
          var v = data.variants.find(function (x) { return x.available; }) || data.variants[0];
          if (!v) throw new Error('no variant');
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
            credentials: 'same-origin'
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart fail');
          btn.innerText = 'Ajouté ✓';
          btn.style.opacity = '1';
          updateCartCount();
          if (typeof window.showStickyCart === 'function') window.showStickyCart(image, title, price);
          return r.json();
        })
        .then(function () { setTimeout(function () { resetBtn(btn, original); }, 2000); })
        .catch(function () { resetBtn(btn, original, true); });
    }

    function updateCartCount() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count || 0;
          ['[data-cart-count]', '.cart-count', '.header__icon-bubble', '.cart-badge', '.js-cart-count', '.header-cart-count']
            .forEach(function (sel) {
              document.querySelectorAll(sel).forEach(function (el) {
                if (el.tagName.toLowerCase() === 'input') el.value = count;
                else el.textContent = count;
              });
            });
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: count } }));
        })
        .catch(function () {});
    }

    window.addToCartFromPreview = async function (url, img, name, price, btn) {
      var native = await waitForFn('addToCartFromTable', 1200);
      if (typeof native === 'function') return native(url, img, name, price, btn);
      return fallbackAdd(url, img, name, price, btn);
    };

    window.togglePreviewFavorite = async function (id, btn) {
      var native = await waitForFn('toggleFavorite', 1200);
      if (typeof native === 'function') {
        native(id);
      } else {
        var favs = safeParse(localStorage.getItem('cw_favorites'), []);
        var i = favs.indexOf(id);
        if (i === -1) favs.push(id); else favs.splice(i, 1);
        localStorage.setItem('cw_favorites', JSON.stringify(favs));
        if (typeof window.showToast === 'function') window.showToast('Favori mis à jour', 'success');
      }
      var favs2 = safeParse(localStorage.getItem('cw_favorites'), []);
      var isFav = favs2.indexOf(id) !== -1;
      if (btn) {
        btn.textContent = isFav ? '❤️' : '🤍';
        btn.classList.toggle('active', isFav);
        btn.setAttribute('aria-pressed', isFav ? 'true' : 'false');
        btn.setAttribute('aria-label', isFav ? 'Retirer des favoris' : 'Ajouter aux favoris');
      }
    };
  }

  // --------------------------------------------------------------------------
  // 10. DELEGATED CLICK BUS (cart + favoris) — lazy load bridge au 1er click
  // --------------------------------------------------------------------------
  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-preview-add]');
    if (addBtn) {
      event.preventDefault();
      ensureCartBridge();
      var url = addBtn.dataset.productUrl;
      var image = addBtn.dataset.productImage;
      var title = addBtn.dataset.productTitle;
      var price = parseFloat(addBtn.dataset.productPrice) || 0;
      window.addToCartFromPreview(url, image, title, price, addBtn);
      return;
    }

    var favBtn = event.target.closest('[data-preview-fav]');
    if (favBtn) {
      event.preventDefault();
      ensureCartBridge();
      var id = favBtn.dataset.favoriteId;
      window.togglePreviewFavorite(id, favBtn);
    }
  });
})();

/* QUICK WIN — Pause des animations hors viewport */
(function () {
  if (!('IntersectionObserver' in window)) return;
  const targets = document.querySelectorAll(
    '.hero-nwm, .hero-nw, .hero-nw-welcome'
  );
  if (!targets.length) return;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        e.target.classList.toggle('is-paused', !e.isIntersecting);
      });
    },
    { threshold: 0.01 }
  );
  targets.forEach((el) => io.observe(el));
})();